import React from 'react';

import { WhiteLabelForbiddenAlert } from 'components/WhiteLabelForbiddenAlert';
import { config } from 'environment/config';
import { Outlet } from 'react-router-dom';

export const WhiteLabelAccessGuard = () => {
  const isAuthorizedDomain = () => window.location.host === config.host || config.isDev;

  return !isAuthorizedDomain() ? <WhiteLabelForbiddenAlert /> : <Outlet />;
};
